import { environment } from '@env/environment';

export const APP_CONSTANTS = {
  DEFAULT_LANG: environment.defaultLocale,
  EVENTS_PAGINATION_LIMIT: 20
};

export const EVENT_LIST_LAYOUT_TYPES = {
  GRID: 'grid',
  LIST: 'list'
}

export const WIDGET_TYPE_CONSTANTS = {
  APPOINTMENTS: 'appointments',
  EVENTS: 'events',
  COMPACT: 'compact',
  PRE_DEFINED_SLOTS: 'pre_defined_slots',
  TOUR: 'tour'
};

export const LS_KEYS = {
  PARTNER_OBJECT: 'cbp_pobj_',
};

export const TEMPLATE_CONSTANTS_IDS = {
  WHITELABEL: {
    WHITELABEL_BOOKINGPAGE_PAGETITLE: 102,
    WHITELABEL_BOOKINGPAGE_DESCRIPTION_APPOINTMENT: 103,
    WHITELABEL_BOOKINGPAGE_DESCRIPTION_EVENT: 104
  },
  EVENT_WIDGET_LABELS: {
    WIDGET_EVENT_NO_MORE_FREE_SLOTS_LABEL: 151,
    WIDGET_EVENT_BOOK_LABEL: 154
  },
}

export const CHILD_TO_PARENT_EDIT_EVENTS = {
  DESCRIPTION: 'PARTNER.DESCRIPTION',
  APPOINTMENT_TAB: 'BOOKING_PAGE_HIDE_APPOINTMENT_TAB',
  EVENT_TAB: 'BOOKING_PAGE_HIDE_EVENT_TAB',
  EMPLOYEE_TAB: 'BOOKING_PAGE_HIDE_EMPLOYEE_TAB',
  STORE_TAB: 'BOOKING_PAGE_HIDE_STORE_TAB',
  ABOUT_US_TAB: 'BOOKING_PAGE_HIDE_ABOUT_US_TAB',
  RATINGS_TAB: 'BOOKING_PAGE_HIDE_RATINGS_TAB',
  EDIT_BUSINESS_HOURS: 'PARTNER.BUSINESS_HOURS',
  CALENSO_EDIT_BOOKING_PAGE_FIELDS: 'CALENSO.EDIT_BOOKING_PAGE_FIELDS',
  PARTNER_SETTING: 'PARTNER.SETTINGS',
  PARTNER_BACKGROUND_IMAGE: 'PARTNER.BACKGROUND',
  PARTNER_LOGO: 'PARTNER.LOGO'
};

export const SUBSCRIPTIONS = {
  SUBSCRIPTION_FREE_TYPE: {
    id: 1,
    name: 'free',
    desc: 'Calenso Free',
    maxNumberOfBookings: 100,
  },
  SUBSCRIPTION_FLATRATE_TYPE: {
    id: 5,
    name: 'flatrate',
    desc: 'Calenso Flatrate',
  },
  SUBSCRIPTION_WHITELABEL_TYPE: {
    id: 100,
    name: 'whitelable',
    desc: 'Calenso Whitelable',
  },
  SUBSCRIPTION_ENTERPRISE_TYPE: {
    id: 101,
    name: 'enterprise',
    desc: 'Calenso Emterprise',
  },
  SUBSCRIPTION_STARTER_TYPE: {
    id: 102,
    name: 'starter',
    desc: 'Calenso Starter',
  },
  SUBSCRIPTION_PRO_TYPE: {
    id: 103,
    name: 'pro',
    desc: 'Calenso Pro',
  },
  SUBSCRIPTION_BUSINESS_TYPE: {
    id: 104,
    name: 'business',
    desc: 'Calenso Business',
  },
  SUBSCRIPTION_NEW_ENTERPRISE_TYPE: {
    id: 105,
    name: 'newEnterprise',
    desc: 'Calenso New Enterprise',
  },
  // v2 tier set (2026 rollout). IDs match config/Seeds/SubscriptionTypesSeed.php
  // in the CakePHP backend (JB-1029).
  SUBSCRIPTION_V2_BASIC_TYPE: {
    id: 202,
    name: 'basic',
    desc: 'Calenso Basic',
  },
  SUBSCRIPTION_V2_STARTER_TYPE: {
    id: 203,
    name: 'starter',
    desc: 'Calenso Starter',
  },
  SUBSCRIPTION_V2_TEAM_TYPE: {
    id: 204,
    name: 'team',
    desc: 'Calenso Team',
  },
  SUBSCRIPTION_V2_ENTERPRISE_TYPE: {
    id: 205,
    name: 'enterprise',
    desc: 'Calenso Enterprise',
  },
};

export const LANGUAGES = [{
  text: 'german',
  value: 'de',
  secondary_text: 'DE',
  locale: 'de_CH',
  flagIcon: '/images/flags/german.png',
}, {
  text: 'french',
  value: 'fr',
  secondary_text: 'FR',
  locale: 'fr_CH',
  flagIcon: '/images/flags/french.png',
}, {
  text: 'italian',
  value: 'it',
  secondary_text: 'IT',
  locale: 'it_CH',
  flagIcon: '/images/flags/italian.png',
}, {
  text: 'english',
  value: 'en',
  secondary_text: 'EN',
  locale: 'en_US',
  flagIcon: '/images/flags/english.png',
}, {
  text: 'dutch',
  value: 'nl',
  secondary_text: 'NL',
  locale: 'nl_NL',
  flagIcon: '/images/flags/dutch.png',
}, {
  text: 'finnish',
  value: 'fi',
  secondary_text: 'FI',
  locale: 'fi_FI',
  flagIcon: '/images/flags/finnish.png',
}, {
  text: 'polish',
  value: 'pl',
  secondary_text: 'PL',
  locale: 'pl_PL',
  flagIcon: '/images/flags/polish.png',
}, {
  text: 'spanish',
  value: 'es',
  secondary_text: 'ES',
  locale: 'es_ES',
  flagIcon: '/images/flags/spanish.png',
}, {
  text: 'swedish',
  value: 'sv',
  secondary_text: 'SE',
  locale: 'sv_SE',
  flagIcon: '/images/flags/swedish.png',
}];

export const SVG_ICONS = [
  'email', 'location', 'location-fill', 'website', 'mobile', 'arrow-down', 'camera', 'pencil', 'grid', 'list', 'check-mark', 'info', 'times', 'more-attendees', 'add-guest', 'expand-less', 'chevron-right', 'spinner'
];

export const CONFERENCE_ERROR_CODES = {
  EXPIRED: 410,
  NOT_BELONGING: 401
};

export const CONFERENCE_WORKERS_LIMIT = {
  MAX_COUNT_TO_SHOW_LESS: 9,
  DEFAULT_LIST_COUNT: 7
};

export const PARTNER_ERROR_CODES = {
  NOT_ACTIVE_SUBSCRIPTION: 403,
  // No account carries this booking name. The only response allowed to turn the SSR
  // render into a real HTTP 404 — every other failure keeps 200 so a transient API
  // problem can never deindex a live booking page.
  PARTNER_NOT_FOUND: 404,
  // ...and the status ALONE is not enough to conclude that. Unlike the 403s below, the
  // not-found response carries no `error_code`, and CakePHP answers a wrong route or a
  // wrong HTTP method with a bare 404 as well ("Controller class Api could not be
  // found."). Matching this message POSITIVELY is what stops an API deploy mismatch —
  // which 404s every request — from stamping 404 + noindex onto every live partner page
  // at once. If the backend ever grows a real `partner_not_found` error_code, switch to
  // it; until then a changed message degrades to "transient", which is the safe side.
  PARTNER_NOT_FOUND_MESSAGE: 'No account found with this booking name!',
  // Transient failure. Tells crawlers to retry and KEEP the existing index entry, where
  // a 200 carrying the generic shell leaves them to conclude the content changed — the
  // exact mistake that let another partner's name onto this one's search result.
  SERVICE_UNAVAILABLE: 503,
  // Machine-readable code from errors[0].error_code. A blocked partner also
  // answers 403, so the status alone cannot tell the two cases apart.
  PARTNER_BLOCKED: 'partner_blocked',
  // Partner's booking widget is switched off (JB-1637). Also a 403, distinct
  // from partner_blocked: the account is alive, only online booking is paused.
  BOOKING_WIDGET_DISABLED: 'booking_widget_disabled'
};

export const WIDGET_APPOINTMENT_TYPE = {
  INTERNAL_APPOINTMENT: 'internal_appointment',
  EXTERNAL_APPOINTMENT: 'external_appointment',
  EXTERNAL_GROUP_APPOINTMENT: 'external_group_appointment',
  EXTERNAL_PRE_DEFINED_SLOTS: 'external_pre_defined_slots',
  EXTERNAL_TOUR: 'external_tour',
}
